import { render } from "./DragAndDropZone.vue?vue&type=template&id=3af85c13&scoped=true"
import script from "./DragAndDropZone.vue?vue&type=script&lang=js"
export * from "./DragAndDropZone.vue?vue&type=script&lang=js"

import "./DragAndDropZone.vue?vue&type=style&index=0&id=3af85c13&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af85c13"]])

export default __exports__